const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003/api';

export interface SheetData {
  name: string;
  data: string[][];
}

export interface LunchOrdersResponse {
  success: boolean;
  sheets: SheetData[];
  fetchedAt: string;
  error?: string;
}

export const lunchOrdersApiService = {
  fetchLunchOrders: async (): Promise<LunchOrdersResponse> => {
    try {
      const response = await fetch(`${API_BASE_URL}/lci-lunch-orders`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch lunch orders');
      }

      return data;
    } catch (error) {
      console.error('Error fetching lunch orders from API:', error);
      throw error;
    }
  },
};
